import { cacheTypes, getMethodByDispatcher, postMethodByDispatcher } from "../../../store/api/CommonFunctions";

export function getStorageStatusReport (data)
{
    return dispatch=> {
    dispatch({
        type:"STG_STATUS_FILTERS",
        data:data
    })
    dispatch(postMethodByDispatcher(`api/StorageAPI/GetStorageStatusReport`,data,"STG_STATUS_REPORT","گزارش وضعیت انبار", ()=>{}))
};
}
export function GetInventoryTurnoverReport (data)
{
    return dispatch=> {
    dispatch({
        type:"INVENTORY_TURNOVER_FILTERS",
        data:data
    })
    dispatch(postMethodByDispatcher(`api/StorageAPI/GetInventoryTurnoverReport`,data,"INVENTORY_TURNOVER_REPORT","گزارش کاردکس کالا", ()=>{}))
};
}
export function setTurnoverFilters(data)
{
    return dispatch =>
    dispatch({
        type:"INVENTORY_TURNOVER_FILTERS",
        data:data
    })
}
export function getInvoiceDetailsReport(data)
{
    return dispatch =>{
        dispatch({
            type:"INVOICE_DETAILES_FILTERS",
            data:data
        });
        dispatch(postMethodByDispatcher(`api/InvoiceAPI/GetInvoiceDetailsReport`,data, "INVOICE_DETAILS_REPORT", "ریز خرید و فروش"));
    }
}
export function getStorageValueReport(storageName)
{
    return dispatch => dispatch(getMethodByDispatcher(`api/StorageAPI/GetStorageValueReport?storageName=${storageName}`,"STORAGE_VALUE_REPORT",cacheTypes.NoCache, "گزارش ارزش انبارها"));
}